export default __webpack_public_path__ + "static/media/july2023-3.abdfb282.jpg";